(function () {
  if (window.SOUNPLACE_PRODUCT_TEMPLATE_ACTIVE === true) return;
  window.SOUNPLACE_PRODUCT_TEMPLATE_ACTIVE = true;

  window.SOUNPLACE_AUDIO_MANAGER = window.SOUNPLACE_AUDIO_MANAGER || {
    current: null,
    players: []
  };

  var MANAGER = window.SOUNPLACE_AUDIO_MANAGER;

    function initReveal() {
    var elements = document.querySelectorAll('[data-sounplace-reveal]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var element = entry.target;
        var isFixedBonus = element.classList.contains('sounplace-bonus-stack-item');

        if (entry.isIntersecting) {
          element.classList.add('is-visible');
          return;
        }

        if (isFixedBonus) {
          element.classList.remove('is-visible');
        }
      });
    }, { threshold: 0.16 });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function seededHeight(seed, index) {
    var value = Math.sin(seed * 999 + index * 12.9898) * 43758.5453;
    var normalized = value - Math.floor(value);
    var shape = Math.sin(index * 0.31 + seed) * 0.5 + 0.5;
    return Math.round(12 + normalized * 46 + shape * 34);
  }

  function parsePeaks(peaksString) {
  if (!peaksString || typeof peaksString !== 'string') return null;

  var cleaned = peaksString
    .replace(/\[/g, '')
    .replace(/\]/g, '')
    .replace(/\n/g, ',')
    .replace(/\s+/g, ',');

  var values = cleaned
    .split(',')
    .map(function (value) {
      return Number(value.trim());
    })
    .filter(function (value) {
      return !isNaN(value) && isFinite(value);
    });

  if (!values.length) return null;

  return values;
}

function normalizePeaks(values) {
  var max = Math.max.apply(null, values);
  var min = Math.min.apply(null, values);

  if (max <= 0) return values.map(function () { return 12; });

  return values.map(function (value) {
    var normalized;

    if (max <= 1) {
      normalized = value * 100;
    } else if (max <= 100) {
      normalized = value;
    } else {
      normalized = (value / max) * 100;
    }

    return Math.max(8, Math.min(100, Math.round(normalized)));
  });
}

function resamplePeaks(values, total) {
  if (!values || !values.length) return null;
  if (values.length === total) return values;

  var result = [];

  for (var i = 0; i < total; i += 1) {
    var start = Math.floor((i / total) * values.length);
    var end = Math.floor(((i + 1) / total) * values.length);

    if (end <= start) end = start + 1;

    var sum = 0;
    var count = 0;

    for (var j = start; j < end && j < values.length; j += 1) {
      sum += values[j];
      count += 1;
    }

    result.push(count ? Math.round(sum / count) : values[start] || 10);
  }

  return result;
}

function getPlayerStyles(playerOrElement) {
  var el = playerOrElement.el || playerOrElement;
  var styles = window.getComputedStyle(el);

  return {
    inactiveColor: styles.getPropertyValue('--wave-color').trim() || '#6f6a78',
    activeColor: styles.getPropertyValue('--wave-progress-color').trim() || '#ff174f',
    buttonColor: styles.getPropertyValue('--audio-button-color').trim() || '#ffffff',
    gap: parseFloat(styles.getPropertyValue('--wave-gap')) || 3
  };
}

function drawWaveCanvas(player, ratio) {
  if (!player || !player.canvas || !player.peaks) return;

  ratio = Math.max(0, Math.min(1, ratio || 0));

  var canvas = player.canvas;
  var ctx = canvas.getContext('2d');
  var wrap = player.waveWrap || player.wave;
  var rect = wrap.getBoundingClientRect();

  if (!rect.width || !rect.height) return;

  var dpr = window.devicePixelRatio || 1;
  var width = Math.round(rect.width * dpr);
  var height = Math.round(rect.height * dpr);

  if (canvas.width !== width || canvas.height !== height) {
    canvas.width = width;
    canvas.height = height;
  }

  canvas.style.width = rect.width + 'px';
  canvas.style.height = rect.height + 'px';

  ctx.clearRect(0, 0, width, height);

  var styles = getPlayerStyles(player);
  var total = player.peaks.length;
  var gap = Math.max(1, styles.gap * dpr);
  var availableWidth = width - gap * (total - 1);
  var barWidth = Math.max(1, availableWidth / total);
  var radius = Math.min(barWidth / 2, 999);
  var activeCount = Math.round(ratio * total);

  for (var i = 0; i < total; i += 1) {
    var peak = player.peaks[i] || 8;
    var barHeight = Math.max(3 * dpr, (peak / 100) * height);
    var x = i * (barWidth + gap);
    var y = (height - barHeight) / 2;

    ctx.fillStyle = i < activeCount ? styles.activeColor : styles.inactiveColor;

    if (ctx.roundRect) {
      ctx.beginPath();
      ctx.roundRect(x, y, barWidth, barHeight, radius);
      ctx.fill();
    } else {
      ctx.fillRect(x, y, barWidth, barHeight);
    }
  }

  if (player.button) {
    player.button.style.color = styles.buttonColor;
  }
}

function buildWave(wave, bars, seed, peaksString) {
  if (!wave || wave.dataset.ready === 'true') return null;

  var total = Number(bars) || 96;
  var waveSeed = Number(seed) || 7;
  var rawPeaks = parsePeaks(peaksString);
  var peakValues = null;

  if (rawPeaks && rawPeaks.length) {
    peakValues = resamplePeaks(normalizePeaks(rawPeaks), total);
  } else {
    peakValues = [];

    for (var i = 0; i < total; i += 1) {
      peakValues.push(seededHeight(waveSeed, i));
    }
  }

  wave.innerHTML = '';

  var canvas = document.createElement('canvas');
  canvas.className = 'sounplace-audio-player__canvas';
  canvas.setAttribute('aria-hidden', 'true');

  wave.appendChild(canvas);
  wave.dataset.ready = 'true';

  return {
    canvas: canvas,
    peaks: peakValues
  };
}

  function paintProgress(player, ratio) {
  drawWaveCanvas(player, ratio);
}

  function updateProgress(player) {
    if (!player || !player.audio || player.audio.paused) return;

    if (player.audio.duration && isFinite(player.audio.duration)) {
      paintProgress(player, player.audio.currentTime / player.audio.duration);
    }

    player.raf = requestAnimationFrame(function () {
      updateProgress(player);
    });
  }

  function setButton(player, playing) {
    if (!player.button) return;
    player.button.textContent = playing ? '❚❚' : '▶';
    player.button.setAttribute('aria-label', playing ? 'Pause audio' : 'Play audio');
  }

  function pausePlayer(player) {
    if (!player) return;

    try {
      player.audio.pause();
    } catch (e) {}

    cancelAnimationFrame(player.raf);
    setButton(player, false);

    if (MANAGER.current === player) {
      MANAGER.current = null;
    }
  }

  function pauseOthers(except) {
    MANAGER.players.forEach(function (player) {
      if (player !== except) pausePlayer(player);
    });
  }

  function applySeek(player, ratio, commit) {
  player.pendingSeekRatio = ratio;
  paintProgress(player, ratio);

  if (!commit) return;

  if (player.audio.duration && isFinite(player.audio.duration)) {
    try {
      player.audio.currentTime = ratio * player.audio.duration;
      player.pendingSeekRatio = null;
    } catch (e) {}
  }
}

function startSmoothSeek(player) {
  if (!player || !player.audio) return;

  player.wasMutedBeforeSeek = player.audio.muted;
  player.volumeBeforeSeek = player.audio.volume;

  if (!player.audio.paused) {
    player.audio.muted = true;
  }
}

function endSmoothSeek(player) {
  if (!player || !player.audio) return;

  window.setTimeout(function () {
    player.audio.muted = !!player.wasMutedBeforeSeek;

    if (typeof player.volumeBeforeSeek === 'number') {
      player.audio.volume = player.volumeBeforeSeek;
    }
  }, 70);
}

  function applyPendingSeek(player) {
    if (typeof player.pendingSeekRatio !== 'number') return;
    if (!player.audio.duration || !isFinite(player.audio.duration)) return;

    try {
      player.audio.currentTime = player.pendingSeekRatio * player.audio.duration;
      paintProgress(player, player.pendingSeekRatio);
      player.pendingSeekRatio = null;
    } catch (e) {}
  }

  function playPlayer(player) {
    pauseOthers(player);

    MANAGER.current = player;

    var promise = player.audio.play();

    setButton(player, true);
    updateProgress(player);

    if (promise && typeof promise.then === 'function') {
      promise.then(function () {
        applyPendingSeek(player);
        setButton(player, true);
        updateProgress(player);
      }).catch(function () {
        setButton(player, false);
      });
    }
  }

  function getRatioFromEvent(event, element) {
    var point = event.changedTouches && event.changedTouches.length
      ? event.changedTouches[0]
      : event;

    var rect = element.getBoundingClientRect();
    var clientX = point.clientX;

    if (typeof clientX !== 'number' || !rect.width) return null;

    return Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
  }

  function initSingleAudioPlayer(el) {
  if (!el || el.dataset.initialized === 'true') return;

  var src = el.dataset.audio;
  var wave = el.querySelector('[data-sounplace-wave]');
  var waveWrap = el.querySelector('[data-sounplace-wave-wrap]') || wave;
  var button = el.querySelector('[data-sounplace-play]');
  var bars = el.dataset.bars;
  var seed = el.dataset.seed;
  var peaks = el.dataset.peaks;

  if (!src || !wave || !waveWrap || !button) return;

  var waveData = buildWave(wave, bars, seed, peaks);

  var audio = new Audio();
  audio.src = src;
  audio.preload = 'none';
  audio.playsInline = true;

  var player = {
    el: el,
    wave: wave,
    waveWrap: waveWrap,
    button: button,
    audio: audio,
    canvas: waveData ? waveData.canvas : null,
    peaks: waveData ? waveData.peaks : null,
    raf: null,
    pendingSeekRatio: null,
    isSeeking: false,
    seekIntent: null,
    pointerStartX: 0,
    pointerStartY: 0,
    smoothSeekActive: false
  };

  paintProgress(player, 0);

  MANAGER.players.push(player);

  audio.addEventListener('loadedmetadata', function () {
    applyPendingSeek(player);
  });

  audio.addEventListener('canplay', function () {
    applyPendingSeek(player);
  });

  audio.addEventListener('timeupdate', function () {
    if (!audio.paused && audio.duration && isFinite(audio.duration)) {
      paintProgress(player, audio.currentTime / audio.duration);
    }
  });

  audio.addEventListener('ended', function () {
    pausePlayer(player);
    paintProgress(player, 0);
  });

  function handleScrubStart(event) {
    player.pointerStartX = event.clientX;
    player.pointerStartY = event.clientY;
    player.seekIntent = event.pointerType === 'mouse' ? 'seek' : 'pending';
    player.isSeeking = player.seekIntent === 'seek';

    if (!player.isSeeking) return;

    event.preventDefault();
    startSmoothSeek(player);
    player.smoothSeekActive = true;

    var ratio = getRatioFromEvent(event, waveWrap);

    if (ratio !== null) {
      applySeek(player, ratio, !audio.paused);
    }

    capturePointer(event);
  }

  function handleScrubMove(event) {
    if (player.seekIntent === 'pending') {
      var deltaX = event.clientX - player.pointerStartX;
      var deltaY = event.clientY - player.pointerStartY;
      var horizontalDistance = Math.abs(deltaX);
      var verticalDistance = Math.abs(deltaY);

      if (Math.max(horizontalDistance, verticalDistance) < 8) return;

      if (verticalDistance > horizontalDistance) {
        player.seekIntent = 'scroll';
        player.isSeeking = false;
        return;
      }

      player.seekIntent = 'seek';
      player.isSeeking = true;
      startSmoothSeek(player);
      player.smoothSeekActive = true;
      capturePointer(event);
    }

    if (player.seekIntent !== 'seek' || !player.isSeeking) return;

    event.preventDefault();

    var ratio = getRatioFromEvent(event, waveWrap);
    if (ratio === null) return;

    applySeek(player, ratio, false);
  }

  function handleScrubEnd(event) {
    if (player.seekIntent === 'scroll' || player.seekIntent === null) {
      resetSeekState();
      return;
    }

    if (player.seekIntent === 'pending') {
      var deltaX = Math.abs(event.clientX - player.pointerStartX);
      var deltaY = Math.abs(event.clientY - player.pointerStartY);

      if (deltaY > deltaX && deltaY >= 8) {
        resetSeekState();
        return;
      }

      player.seekIntent = 'seek';
      player.isSeeking = true;
      startSmoothSeek(player);
      player.smoothSeekActive = true;
    }

    if (!player.isSeeking) {
      resetSeekState();
      return;
    }

    event.preventDefault();

    var ratio = getRatioFromEvent(event, waveWrap);

    if (ratio !== null) {
      player.pendingSeekRatio = ratio;
      paintProgress(player, ratio);

      if (!audio.paused) {
        applySeek(player, ratio, true);
      }
    }

    if (player.smoothSeekActive) endSmoothSeek(player);
    resetSeekState();
  }

  function handleScrubCancel() {
    if (player.seekIntent === 'seek' && !audio.paused && typeof player.pendingSeekRatio === 'number') {
      applySeek(player, player.pendingSeekRatio, true);
    }

    if (player.smoothSeekActive) endSmoothSeek(player);
    resetSeekState();
  }

  function capturePointer(event) {
    if (!waveWrap.setPointerCapture || event.pointerId === undefined) return;

    try {
      waveWrap.setPointerCapture(event.pointerId);
    } catch (e) {}
  }

  function resetSeekState() {
    player.isSeeking = false;
    player.seekIntent = null;
    player.smoothSeekActive = false;
  }

  waveWrap.addEventListener('pointerdown', handleScrubStart);
  waveWrap.addEventListener('pointermove', handleScrubMove);
  waveWrap.addEventListener('pointerup', handleScrubEnd);
  waveWrap.addEventListener('pointercancel', handleScrubCancel);
  waveWrap.addEventListener('lostpointercapture', handleScrubCancel);

  button.addEventListener('click', function () {
    if (audio.paused) {
      applyPendingSeek(player);
      playPlayer(player);
    } else {
      pausePlayer(player);
    }
  });

  el.dataset.initialized = 'true';
}

function initAudioPlayers() {
  var playerEls = document.querySelectorAll('[data-sounplace-audio-player]');
  if (!playerEls.length) return;

  playerEls.forEach(function (el) {
    initSingleAudioPlayer(el);
  });
}

function initAudioPlayersLazy() {
  var playerEls = document.querySelectorAll('[data-sounplace-audio-player]');
  if (!playerEls.length) return;

  if (!('IntersectionObserver' in window)) {
    initAudioPlayers();
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      initSingleAudioPlayer(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '500px 0px',
    threshold: 0.01
  });

  playerEls.forEach(function (el) {
    if (el.dataset.initialized !== 'true') {
      observer.observe(el);
    }
  });
}

  function initFaqAccordions() {
  document.querySelectorAll('[data-sounplace-faq-item]').forEach(function (item) {
    if (item.dataset.faqInitialized === 'true') return;

    var summary = item.querySelector('summary');
    var answer = item.querySelector('[data-sounplace-faq-answer]');
    var inner = answer && answer.firstElementChild;
    if (!summary || !answer || !inner) return;

    var animation = null;
    var expanded = item.open;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    answer.style.transition = 'none';
    answer.style.height = expanded ? 'auto' : '0px';

    function cancelAnimation() {
      if (!animation) return;
      animation.onfinish = null;
      animation.oncancel = null;
      animation.cancel();
      animation = null;
    }

    function settle() {
      cancelAnimation();
      item.open = expanded;
      answer.style.height = expanded ? 'auto' : '0px';
      item.dataset.animating = 'false';
      answer.inert = !expanded;
    }

    function setExpanded(next) {
      var start = item.open ? answer.getBoundingClientRect().height : 0;
      cancelAnimation();
      expanded = next;
      answer.style.height = start + 'px';
      item.open = true;
      answer.inert = !expanded;
      var end = expanded ? inner.getBoundingClientRect().height : 0;

      if (motion.matches || typeof answer.animate !== 'function' || Math.abs(end - start) < 1) {
        settle();
        return;
      }

      item.dataset.animating = 'true';
      animation = answer.animate([
        { height: start + 'px' },
        { height: end + 'px' }
      ], {
        duration: Math.min(260, Math.max(160, Math.abs(end - start) * 0.45)),
        easing: 'cubic-bezier(.22,.61,.36,1)',
        fill: 'both'
      });
      animation.onfinish = settle;
    }

    summary.addEventListener('click', function (event) {
      if (event.target.closest('a, button, input, select, textarea')) return;
      event.preventDefault();
      setExpanded(!expanded);
    });

    answer.addEventListener('load', function () {
      if (animation) settle();
    }, true);

    var observer = typeof ResizeObserver === 'function' ? new ResizeObserver(function () {
      if (animation) {
        var target = expanded ? inner.getBoundingClientRect().height : 0;
        var frames = animation.effect.getKeyframes();
        if (Math.abs(target - parseFloat(frames[frames.length - 1].height)) > 1) settle();
      }
    }) : null;
    if (observer) observer.observe(inner);

    function cleanup(event) {
      if (!event.target.contains(item)) return;
      settle();
      if (observer) observer.disconnect();
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
    item.dataset.faqInitialized = 'true';
    answer.inert = !expanded;
  });
}

var KIT_VIDEO_MANAGER = window.SOUNPLACE_KIT_VIDEO_MANAGER || { current: null };
window.SOUNPLACE_KIT_VIDEO_MANAGER = KIT_VIDEO_MANAGER;

function usesAppleAlphaVideo() {
  var userAgent = navigator.userAgent || '';
  var isIOSDevice = /iPad|iPhone|iPod/i.test(userAgent);
  var isIPadDesktopMode = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  var isDesktopSafari = /Safari/i.test(userAgent) &&
    !/Chrome|Chromium|CriOS|Edg|EdgiOS|OPR|OPiOS|FxiOS|Android/i.test(userAgent);

  return isIOSDevice || isIPadDesktopMode || isDesktopSafari;
}

function kitVideoIsReduced() {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var saveData = !!(connection && connection.saveData);
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return saveData || reducedMotion;
}

function getKitVideoSource(video) {
  if (!video) return '';

  return usesAppleAlphaVideo()
    ? (video.dataset.appleSrc || '')
    : (video.dataset.webmSrc || '');
}

function setKitVideoReady(video, ready) {
  if (!video) return;

  var media = video.closest('[data-sounplace-kit-media]');
  if (!media) return;

  media.classList.toggle('is-video-ready', !!ready);
}

function pauseKitVideo(video) {
  if (!video) return;

  try {
    video.pause();
  } catch (e) {}
}

function releaseKitVideo(video) {
  if (!video) return;

  pauseKitVideo(video);
  setKitVideoReady(video, false);

  if (video.getAttribute('src')) {
    video.removeAttribute('src');

    try {
      video.load();
    } catch (e) {}
  }

  video.dataset.loadedSource = '';

  if (KIT_VIDEO_MANAGER.current === video) {
    KIT_VIDEO_MANAGER.current = null;
  }
}

function playKitVideo(video) {
  if (!video || kitVideoIsReduced() || document.hidden) return;

  var source = getKitVideoSource(video);
  if (!source || video.dataset.failedSource === source) return;

  if (KIT_VIDEO_MANAGER.current && KIT_VIDEO_MANAGER.current !== video) {
    releaseKitVideo(KIT_VIDEO_MANAGER.current);
  }

  KIT_VIDEO_MANAGER.current = video;
  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;

  if (video.dataset.loadedSource !== source) {
    setKitVideoReady(video, false);
    video.src = source;
    video.dataset.loadedSource = source;

    try {
      video.load();
    } catch (e) {}
  }

  var playPromise;

  try {
    playPromise = video.play();
  } catch (e) {
    setKitVideoReady(video, false);
    return;
  }

  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function () {
      setKitVideoReady(video, false);
    });
  }
}

function initKitExplorerVideos(explorer) {
  var videos = explorer.querySelectorAll('[data-sounplace-kit-video]');
  var state = { nearViewport: false };
  var observer = null;
  var motionQuery = null;
  var handleMotionChange = null;

  function getActiveVideo() {
    var activePanel = explorer.querySelector('.sounplace-kit-panel.is-active');
    return activePanel ? activePanel.querySelector('[data-sounplace-kit-video]') : null;
  }

  function refreshActiveVideo() {
    var activeVideo = getActiveVideo();
    if (!activeVideo) return;

    if (state.nearViewport && !document.hidden && !kitVideoIsReduced()) {
      playKitVideo(activeVideo);
    } else {
      pauseKitVideo(activeVideo);
    }
  }

  function switchTo(currentPanel, nextPanel) {
    var currentVideo = currentPanel ? currentPanel.querySelector('[data-sounplace-kit-video]') : null;
    var nextVideo = nextPanel ? nextPanel.querySelector('[data-sounplace-kit-video]') : null;

    if (currentVideo && currentVideo !== nextVideo) {
      releaseKitVideo(currentVideo);
    }

    if (nextVideo && state.nearViewport && !document.hidden && !kitVideoIsReduced()) {
      playKitVideo(nextVideo);
    }
  }

  if (!videos.length) {
    return { switchTo: function () {} };
  }

  videos.forEach(function (video) {
    video.addEventListener('playing', function () {
      if (KIT_VIDEO_MANAGER.current === video) {
        setKitVideoReady(video, true);
      }
    });

    video.addEventListener('error', function () {
      var failedSource = video.dataset.loadedSource;
      if (failedSource) video.dataset.failedSource = failedSource;
      releaseKitVideo(video);
    });
  });

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        state.nearViewport = entry.isIntersecting;
        refreshActiveVideo();
      });
    }, {
      rootMargin: '400px 0px',
      threshold: 0.01
    });

    observer.observe(explorer);
  } else {
    state.nearViewport = true;
    refreshActiveVideo();
  }

  document.addEventListener('visibilitychange', refreshActiveVideo);

  if (window.matchMedia) {
    motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    handleMotionChange = function () {
      if (motionQuery.matches) {
        videos.forEach(releaseKitVideo);
      } else {
        refreshActiveVideo();
      }
    };

    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', handleMotionChange);
    } else if (motionQuery.addListener) {
      motionQuery.addListener(handleMotionChange);
    }
  }

  function cleanupExplorerVideos(event) {
    if (event && event.target && event.target.contains && !event.target.contains(explorer)) return;

    if (observer) observer.disconnect();
    document.removeEventListener('visibilitychange', refreshActiveVideo);

    if (motionQuery && handleMotionChange) {
      if (motionQuery.removeEventListener) {
        motionQuery.removeEventListener('change', handleMotionChange);
      } else if (motionQuery.removeListener) {
        motionQuery.removeListener(handleMotionChange);
      }
    }

    videos.forEach(releaseKitVideo);
    document.removeEventListener('shopify:section:unload', cleanupExplorerVideos);
  }

  document.addEventListener('shopify:section:unload', cleanupExplorerVideos);

  return { switchTo: switchTo };
}

  function initKitExplorers() {
  var explorers = document.querySelectorAll('[data-sounplace-kit-explorer]');
  if (!explorers.length) return;

  explorers.forEach(function (explorer) {
    if (explorer.dataset.tabsInitialized === 'true') return;

    var tabs = explorer.querySelectorAll('[data-sounplace-kit-tab]');
    var panels = explorer.querySelectorAll('[data-sounplace-kit-panel]');

    if (!tabs.length || !panels.length) return;

    var mediaController = initKitExplorerVideos(explorer);

    tabs.forEach(function (tab) {
  tab.addEventListener('click', function () {
    var index = tab.dataset.sounplaceKitTab;
    var nextPanel = explorer.querySelector('[data-sounplace-kit-panel="' + index + '"]');
    var currentPanel = explorer.querySelector('.sounplace-kit-panel.is-active');
    var panelsWrap = explorer.querySelector('.sounplace-kit-explorer__panels');

    if (!nextPanel || nextPanel === currentPanel) return;

    if (window.SOUNPLACE_AUDIO_MANAGER && window.SOUNPLACE_AUDIO_MANAGER.current) {
      var activePlayer = window.SOUNPLACE_AUDIO_MANAGER.current;
      if (activePlayer.el && explorer.contains(activePlayer.el) && !activePlayer.audio.paused && activePlayer.button) {
        activePlayer.button.click();
      }
    }

    tabs.forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-selected', 'false');
    });

    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');

    if (panelsWrap && currentPanel) {
      panelsWrap.style.height = currentPanel.offsetHeight + 'px';
    }

    if (currentPanel) {
      currentPanel.classList.add('is-leaving');
      currentPanel.classList.remove('is-active');
    }

    nextPanel.classList.add('is-active');
    nextPanel.classList.add('is-entering');

    mediaController.switchTo(currentPanel, nextPanel);

    if (panelsWrap) {
      requestAnimationFrame(function () {
        panelsWrap.style.height = nextPanel.offsetHeight + 'px';
      });
    }

    window.setTimeout(function () {
      if (currentPanel) currentPanel.classList.remove('is-leaving');
      nextPanel.classList.remove('is-entering');

      if (panelsWrap) {
        panelsWrap.style.height = '';
      }
    }, 380);
  });
});

    explorer.dataset.tabsInitialized = 'true';
  });
}

/* FASE 11.1 · Scroll cinematográfico único y coordinado con Dawn. */
function initSmoothScrollLinks() {
  var targetMap = {
    audio: { selectors: ['.sounplace-audio-showcase'], align: 'start' },
    hero: { selectors: ['.sounplace-hero-pro'], align: 'start' },
    audio_cards: { selectors: ['.sounplace-audio-cards'], align: 'start' },
    preview: { selectors: ['.sounplace-preview-grid-minimal'], align: 'start' },
    kit: { selectors: ['.sounplace-kit-explorer'], align: 'start' },
    bonus: { selectors: ['.sounplace-bonus-stack'], align: 'start' },
    inside: { selectors: ['.sounplace-inside-bundle'], align: 'start' },
    value: {
      selectors: [
        '.sounplace-value-list__cta',
        '.sounplace-value-card--highlight .sounplace-value-card__bottom',
        '.sounplace-value-list'
      ],
      align: 'purchase'
    },
    faq: { selectors: ['.sounplace-faq'], align: 'start' }
  };

  if (document.documentElement.dataset.sounplaceScrollInitialized === 'true') return;

  var activeScroll = null;

  function resolveTarget(config) {
    if (!config) return null;

    for (var index = 0; index < config.selectors.length; index += 1) {
      var match = document.querySelector(config.selectors[index]);
      if (match) return match;
    }

    return null;
  }

  function prepareHeader() {
    var component = document.querySelector('sticky-header');
    var sectionHeader = document.querySelector('.section-header');
    var previousPreventHide = component ? component.preventHide : undefined;

    if (!sectionHeader) {
      return {
        height: 0,
        release: function () {}
      };
    }

    if (component) component.preventHide = true;

    sectionHeader.classList.remove('shopify-section-header-hidden');
    sectionHeader.classList.add('shopify-section-header-sticky', 'sounplace-scroll-header-lock');

    return {
      height: sectionHeader.getBoundingClientRect().height,
      release: function () {
        sectionHeader.classList.remove('sounplace-scroll-header-lock');
        sectionHeader.classList.add('shopify-section-header-sticky', 'animate');
        sectionHeader.classList.remove('shopify-section-header-hidden');

        if (component) {
          component.preventHide = previousPreventHide === true;
          component.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        }
      }
    };
  }

  function revealDestination(target) {
    var revealRoot = target.closest('[data-sounplace-reveal]');
    if (revealRoot) revealRoot.classList.add('is-visible');

    target.querySelectorAll('[data-sounplace-reveal]').forEach(function (element) {
      element.classList.add('is-visible');
    });
  }

  function calculateDestination(target, align, headerHeight) {
    var rect = target.getBoundingClientRect();
    var absoluteTop = window.pageYOffset + rect.top;
    var destination;

    if (align === 'purchase') {
      var availableHeight = Math.max(320, window.innerHeight - headerHeight);
      var visibleTargetHeight = Math.min(rect.height, availableHeight * 0.72);
      var centeringSpace = Math.max(20, (availableHeight - visibleTargetHeight) / 2);
      destination = absoluteTop - headerHeight - centeringSpace;
    } else {
      destination = absoluteTop - headerHeight - 24;
    }

    var documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight
    );
    var maximum = Math.max(0, documentHeight - window.innerHeight);

    return Math.max(0, Math.min(destination, maximum));
  }

  function easeInOutCubic(progress) {
    if (progress < 0.5) return 4 * progress * progress * progress;
    return 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function finishScroll(state, targetKey, completed) {
    if (!state || state.finished) return;
    state.finished = true;

    window.cancelAnimationFrame(state.frameId);
    state.removeCancellationListeners();
    document.documentElement.classList.remove('sounplace-programmatic-scroll');
    state.header.release();

    if (completed) {
      revealDestination(state.target);

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + targetKey);
      }
    }

    if (activeScroll === state) activeScroll = null;
  }

  function addCancellationListeners(cancel) {
    var listenerOptions = { passive: true };
    var keysThatCancel = ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '];

    function cancelFromKeyboard(event) {
      if (keysThatCancel.indexOf(event.key) !== -1) cancel();
    }

    window.addEventListener('wheel', cancel, listenerOptions);
    window.addEventListener('touchstart', cancel, listenerOptions);
    window.addEventListener('pointerdown', cancel, listenerOptions);
    window.addEventListener('keydown', cancelFromKeyboard);

    return function () {
      window.removeEventListener('wheel', cancel, listenerOptions);
      window.removeEventListener('touchstart', cancel, listenerOptions);
      window.removeEventListener('pointerdown', cancel, listenerOptions);
      window.removeEventListener('keydown', cancelFromKeyboard);
    };
  }

  function animateToTarget(target, config, targetKey) {
    if (!target) return;

    if (activeScroll) finishScroll(activeScroll, activeScroll.targetKey, false);

    var header = prepareHeader();
    var state = {
      target: target,
      targetKey: targetKey,
      header: header,
      frameId: null,
      finished: false,
      removeCancellationListeners: function () {}
    };

    activeScroll = state;
    document.documentElement.classList.add('sounplace-programmatic-scroll');

    state.removeCancellationListeners = addCancellationListeners(function () {
      finishScroll(state, targetKey, false);
    });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (state.finished) return;

        var startY = window.pageYOffset || document.documentElement.scrollTop;
        var endY = calculateDestination(target, config.align, header.height);
        var distance = Math.abs(endY - startY);
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion || distance < 2) {
          window.scrollTo(0, endY);
          finishScroll(state, targetKey, true);
          return;
        }

        var duration = Math.min(1350, Math.max(800, 620 + distance * 0.055));
        var startedAt = null;

        function step(timestamp) {
          if (state.finished) return;
          if (startedAt === null) startedAt = timestamp;

          var progress = Math.min(1, (timestamp - startedAt) / duration);
          var nextY = startY + (endY - startY) * easeInOutCubic(progress);
          window.scrollTo(0, Math.round(nextY));

          if (progress < 1) {
            state.frameId = window.requestAnimationFrame(step);
          } else {
            finishScroll(state, targetKey, true);
          }
        }

        state.frameId = window.requestAnimationFrame(step);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var eventTarget = event.target;
    if (!(eventTarget instanceof Element)) return;

    var link = eventTarget.closest('[data-sounplace-smooth-scroll]');
    if (!link) return;

    var targetKey = link.dataset.scrollTarget;
    var config = targetMap[targetKey];
    var target = resolveTarget(config);
    if (!target) return;

    event.preventDefault();
    animateToTarget(target, config, targetKey);
  });

  document.documentElement.dataset.sounplaceScrollInitialized = 'true';
}

window.SOUNPLACE_PRODUCT_TEMPLATE_INIT = function () {
    initReveal();
    initAudioPlayersLazy();
    initKitExplorers();
    initFaqAccordions();
    window.setTimeout(redrawAllPlayers, 120);
  };
  document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initAudioPlayersLazy();
  initKitExplorers();
  initFaqAccordions();
  initSmoothScrollLinks();
});

document.addEventListener('shopify:section:load', function () {
  initReveal();
  initAudioPlayersLazy();
  initKitExplorers();
  initFaqAccordions();
  initSmoothScrollLinks();

  window.setTimeout(function () {
    redrawAllPlayers();
  }, 120);
});

function redrawAllPlayers() {
  MANAGER.players.forEach(function (player) {
    if (!player || !player.audio) return;

    var ratio = 0;

    if (player.audio.duration && isFinite(player.audio.duration)) {
      ratio = player.audio.currentTime / player.audio.duration;
    }

    paintProgress(player, ratio);
  });
}

var redrawTimer = null;

window.addEventListener('resize', function () {
  window.clearTimeout(redrawTimer);

  redrawTimer = window.setTimeout(function () {
    redrawAllPlayers();
  }, 120);
});

window.addEventListener('orientationchange', function () {
  window.setTimeout(function () {
    redrawAllPlayers();
  }, 260);
});
})();
